import { Children, isValidElement, type ReactNode } from "react";

/**
 * Извлекает плоский текст из произвольного ReactNode.
 */
export const reactNodeToText = (node: ReactNode): string => {
  const collect = (n: ReactNode): string => {
    if (n == null || typeof n === "boolean") return "";
    if (typeof n === "string" || typeof n === "number") return String(n);
    if (Array.isArray(n)) return n.map(collect).join("");
    if (isValidElement(n)) {
      return Children.toArray((n.props as { children?: ReactNode }).children)
        .map(collect)
        .join("");
    }
    return "";
  };

  return collect(node).replace(/\s+/g, " ").trim();
};
